import * as React from "react"

const SvgTextSize = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 7.286h-3.5q-.624 0-1.063-.438A1.45 1.45 0 0 1 9 5.786q0-.625.438-1.063a1.45 1.45 0 0 1 1.062-.437h10q.625 0 1.063.437.437.438.437 1.063 0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438H17v11.5q0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438q-.624 0-1.063-.438A1.45 1.45 0 0 1 14 18.786zm-9 5H3.5q-.625 0-1.063-.438A1.45 1.45 0 0 1 2 10.786q0-.625.438-1.063A1.45 1.45 0 0 1 3.5 9.286h6q.624 0 1.063.437.437.438.437 1.063 0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438H8v6.5q0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438q-.624 0-1.063-.438A1.45 1.45 0 0 1 5 18.786z" />
  </svg>
)
export default SvgTextSize
